import { Button, Image, Label, TableRowDisplayEvent, Textbox } from "@mcleod/components";
import { AutogenLayoutDrsPendingDeductList } from "./autogen/AutogenLayoutDrsPendingDeductList";

export class DrsPendingDeductList extends AutogenLayoutDrsPendingDeductList {
    onLoad(): void | Promise<void> {
        this.tableDrsPendingDeduct.addRowDisplayListener((event: TableRowDisplayEvent) => {
            const tableRow = event.getTableRow();
            const modelRow = tableRow.data;
            const baseLink = "lme/settlement/PendingPayAdjustment?mode=update&key=";
            const buttonDrilldown = tableRow.findComponentById("buttonDrilldown") as Button;
            if (buttonDrilldown != null) {
                buttonDrilldown.link = baseLink + modelRow.get("id");
            }

            if(modelRow.getBoolean("out_of_scope")) {
                const imageWarning = tableRow.findComponentById("imageAdjustmentWarning") as Image;
                if(imageWarning) imageWarning.visible = true;
                tableRow.forEveryChildComponent(comp=>{
                    if (comp instanceof Textbox || comp instanceof Label){
                        comp.fontBold = true;
                        comp.color = "warning";
                    }
                })
            }
        });
    }
}
